import httpNodeClient from '@shared/api/httpNodeClient';
import { AllFlagsDataFilters } from '../interfaces/AllFlagsDataFilters';
import { flagsListDataMapFunc } from './helpers/flagsListDataMapFunc';
import { ResponseListFlagData } from './types';
import set from 'lodash/set';
import { AllFlagsPageData } from '../pages/AllFlagsPage/interfaces/AllFlagsPageData';
import { DataWithTotalCount } from '@shared/interfaces/DataWithTotalCount';

export const fetchAllFlagsData = (params: AllFlagsDataFilters): Promise<AllFlagsPageData> => {
  const { sortInfo, ...restParams } = params;

  const filteredParams = Object.entries(restParams).reduce((res, [k, v]) => {
    if (v !== undefined && v !== null) {
      set(res, k, v);
    }
    return res;
  }, {});

  const sortParams = sortInfo?.field
    ? {
        sortBy: sortInfo.field,
        sortDirection: sortInfo.sortDirection,
      }
    : {};

  return httpNodeClient
    .get<DataWithTotalCount<ResponseListFlagData>>('flags', {
      params: {
        ...filteredParams,
        ...sortParams,
        limit: params.limit,
        offset: params.offset,
      },
    })
    .then(({ data: { items, totalCount } }) => ({ totalCount, items: flagsListDataMapFunc(items) }));
};
